import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=fb9e873a&"
import script from "./Events.vue?vue&type=script&lang=js&"
export * from "./Events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb9e873a')) {
      api.createRecord('fb9e873a', component.options)
    } else {
      api.reload('fb9e873a', component.options)
    }
    module.hot.accept("./Events.vue?vue&type=template&id=fb9e873a&", function () {
      api.rerender('fb9e873a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Study/Events.vue"
export default component.exports